/* eslint-disable no-unused-vars */
// !!! IMPORTANT: This file is autogenerated. Please do not edit.!!!
import ComponentRegistry from '../utils/componentRegistry'

// KIT EXAMPLES
import '../pb_kits/playbook/pb_form/pb_form_validation'
import * as AdvancedTable from '../pb_kits/playbook/pb_advanced_table/docs'
import * as Avatar from '../pb_kits/playbook/pb_avatar/docs'
import * as Background from '../pb_kits/playbook/pb_background/docs'
import * as Badge from '../pb_kits/playbook/pb_badge/docs'
import * as Body from '../pb_kits/playbook/pb_body/docs'
import * as BreadCrumbs from '../pb_kits/playbook/pb_bread_crumbs/docs'
import * as Button from '../pb_kits/playbook/pb_button/docs'
import * as ButtonToolbar from '../pb_kits/playbook/pb_button_toolbar/docs'
import * as Caption from '../pb_kits/playbook/pb_caption/docs'
import * as Card from '../pb_kits/playbook/pb_card/docs'
import * as Checkbox from '../pb_kits/playbook/pb_checkbox/docs'
import * as CircleIconButton from '../pb_kits/playbook/pb_circle_icon_button/docs'
import * as Collapsible from '../pb_kits/playbook/pb_collapsible/docs'
import * as Contact from '../pb_kits/playbook/pb_contact/docs'
import * as Container from '../pb_kits/playbook/pb_container/docs'
import * as CopyButton from '../pb_kits/playbook/pb_copy_button/docs'
import * as Currency from '../pb_kits/playbook/pb_currency/docs'
import * as DashboardValue from '../pb_kits/playbook/pb_dashboard_value/docs'
import * as Date from '../pb_kits/playbook/pb_date/docs'
import * as DatePicker from '../pb_kits/playbook/pb_date_picker/docs'
import * as DateRangeInline from '../pb_kits/playbook/pb_date_range_inline/docs'
import * as DateRangeStacked from '../pb_kits/playbook/pb_date_range_stacked/docs'
import * as DateStacked from '../pb_kits/playbook/pb_date_stacked/docs'
import * as DateTime from '../pb_kits/playbook/pb_date_time/docs'
import * as DateTimeStacked from '../pb_kits/playbook/pb_date_time_stacked/docs'
import * as DateYearStacked from '../pb_kits/playbook/pb_date_year_stacked/docs'
import * as Detail from '../pb_kits/playbook/pb_detail/docs'
import * as Dialog from '../pb_kits/playbook/pb_dialog/docs'
import * as DistributionBarDocs from '../pb_kits/playbook/pb_distribution_bar/docs'
import * as Draggable from '../pb_kits/playbook/pb_draggable/docs'
import * as Dropdown from '../pb_kits/playbook/pb_dropdown/docs'
import * as EmptyState from '../pb_kits/playbook/pb_empty_state/docs'
import * as FileUpload from '../pb_kits/playbook/pb_file_upload/docs'
import * as Filter from '../pb_kits/playbook/pb_filter/docs'
import * as FixedConfirmationToast from '../pb_kits/playbook/pb_fixed_confirmation_toast/docs'
import * as Flex from '../pb_kits/playbook/pb_flex/docs'
import * as FormGroup from '../pb_kits/playbook/pb_form_group/docs'
import * as FormPill from '../pb_kits/playbook/pb_form_pill/docs'
import * as FullScreen from '../pb_kits/playbook/pb_full_screen/docs'
import * as Hashtag from '../pb_kits/playbook/pb_hashtag/docs'
import * as Highlight from '../pb_kits/playbook/pb_highlight/docs'
import * as HomeAddressStreet from '../pb_kits/playbook/pb_home_address_street/docs'
import * as Icon from '../pb_kits/playbook/pb_icon/docs'
import * as IconCircle from '../pb_kits/playbook/pb_icon_circle/docs'
import * as IconStatValue from '../pb_kits/playbook/pb_icon_stat_value/docs'
import * as IconValue from '../pb_kits/playbook/pb_icon_value/docs'
import * as Image from '../pb_kits/playbook/pb_image/docs'
import * as LabelPill from '../pb_kits/playbook/pb_label_pill/docs'
import * as LabelValue from '../pb_kits/playbook/pb_label_value/docs'
import * as Layout from '../pb_kits/playbook/pb_layout/docs'
import * as LegendDocs from '../pb_kits/playbook/pb_legend/docs'
import * as Lightbox from '../pb_kits/playbook/pb_lightbox/docs'
import * as Link from '../pb_kits/playbook/pb_link/docs'
import * as List from '../pb_kits/playbook/pb_list/docs'
import * as LoadingInline from '../pb_kits/playbook/pb_loading_inline/docs'
import * as Map from '../pb_kits/playbook/pb_map/docs'
import * as Message from '../pb_kits/playbook/pb_message/docs'
import * as MultiLevelSelect from '../pb_kits/playbook/pb_multi_level_select/docs'
import * as MultipleUsers from '../pb_kits/playbook/pb_multiple_users/docs'
import * as MultipleUsersStacked from '../pb_kits/playbook/pb_multiple_users_stacked/docs'
import * as Nav from '../pb_kits/playbook/pb_nav/docs'
import * as OnlineStatus from '../pb_kits/playbook/pb_online_status/docs'
import * as Overlay from '../pb_kits/playbook/pb_overlay/docs'
import * as Pagination from '../pb_kits/playbook/pb_pagination/docs'
import * as Passphrase from '../pb_kits/playbook/pb_passphrase/docs'
import * as PbBarGraph from '../pb_kits/playbook/pb_pb_bar_graph/docs'
import * as PbCircleChart from '../pb_kits/playbook/pb_pb_circle_chart/docs'
import * as PbGaugeChart from '../pb_kits/playbook/pb_pb_gauge_chart/docs'
import * as PbLineGraph from '../pb_kits/playbook/pb_pb_line_graph/docs'
import * as PbReactPopover from '../pb_kits/playbook/pb_popover/docs'
import * as Person from '../pb_kits/playbook/pb_person/docs'
import * as PersonContact from '../pb_kits/playbook/pb_person_contact/docs'
import * as PhoneNumberInput from '../pb_kits/playbook/pb_phone_number_input/docs'
import * as Pill from '../pb_kits/playbook/pb_pill/docs'
import * as ProgressPills from '../pb_kits/playbook/pb_progress_pills/docs'
import * as ProgressSimple from '../pb_kits/playbook/pb_progress_simple/docs'
import * as ProgressStep from '../pb_kits/playbook/pb_progress_step/docs'
import * as Radio from '../pb_kits/playbook/pb_radio/docs'
import * as RichTextEditor from '../pb_kits/playbook/pb_rich_text_editor/docs'
import * as SectionSeparator from '../pb_kits/playbook/pb_section_separator/docs'
import * as Select from '../pb_kits/playbook/pb_select/docs'
import * as SelectableCard from '../pb_kits/playbook/pb_selectable_card/docs'
import * as SelectableCardIcon from '../pb_kits/playbook/pb_selectable_card_icon/docs'
import * as SelectableIcon from '../pb_kits/playbook/pb_selectable_icon/docs'
import * as SelectableList from '../pb_kits/playbook/pb_selectable_list/docs'
import * as SkeletonLoading from '../pb_kits/playbook/pb_skeleton_loading/docs'
import * as Source from '../pb_kits/playbook/pb_source/docs'
import * as StarRating from '../pb_kits/playbook/pb_star_rating/docs'
import * as StatChange from '../pb_kits/playbook/pb_stat_change/docs'
import * as StatValue from '../pb_kits/playbook/pb_stat_value/docs'
import * as Table from '../pb_kits/playbook/pb_table/docs'
import * as TextInput from '../pb_kits/playbook/pb_text_input/docs'
import * as Textarea from '../pb_kits/playbook/pb_textarea/docs'
import * as Time from '../pb_kits/playbook/pb_time/docs'
import * as TimePicker from 'kits/pb_time_picker/docs'
import * as TimeRangeInline from '../pb_kits/playbook/pb_time_range_inline/docs'
import * as TimeStacked from '../pb_kits/playbook/pb_time_stacked/docs'
import * as Timeline from '../pb_kits/playbook/pb_timeline/docs'
import * as Timestamp from '../pb_kits/playbook/pb_timestamp/docs'
import * as Title from '../pb_kits/playbook/pb_title/docs'
import * as TitleCount from '../pb_kits/playbook/pb_title_count/docs'
import * as TitleDetail from '../pb_kits/playbook/pb_title_detail/docs'
import * as Toggle from '../pb_kits/playbook/pb_toggle/docs'
import * as Tooltip from '../pb_kits/playbook/pb_tooltip/docs'
import * as Typeahead from '../pb_kits/playbook/pb_typeahead/docs'
import * as User from '../pb_kits/playbook/pb_user/docs'
import * as UserBadge from '../pb_kits/playbook/pb_user_badge/docs'
import * as WeekdayStacked from '../pb_kits/playbook/pb_weekday_stacked/docs'

ComponentRegistry.registerComponents({
  ...AdvancedTable,
  ...Avatar,
  ...Background,
  ...Badge,
  ...Body,
  ...BreadCrumbs,
  ...Button,
  ...ButtonToolbar,
  ...Caption,
  ...Card,
  ...Checkbox,
  ...CircleIconButton,
  ...Collapsible,
  ...Contact,
  ...Container,
  ...CopyButton,
  ...Currency,
  ...DashboardValue,
  ...Date,
  ...DatePicker,
  ...DateRangeInline,
  ...DateRangeStacked,
  ...DateStacked,
  ...DateTime,
  ...DateTimeStacked,
  ...DateYearStacked,
  ...Detail,
  ...Dialog,
  ...DistributionBarDocs,
  ...Draggable,
  ...Dropdown,
  ...EmptyState,
  ...FileUpload,
  ...Filter,
  ...FixedConfirmationToast,
  ...Flex,
  ...FormGroup,
  ...FormPill,
  ...FullScreen,
  ...Hashtag,
  ...Highlight,
  ...HomeAddressStreet,
  ...Icon,
  ...IconCircle,
  ...IconStatValue,
  ...IconValue,
  ...Image,
  ...LabelPill,
  ...LabelValue,
  ...Layout,
  ...LegendDocs,
  ...Lightbox,
  ...Link,
  ...List,
  ...LoadingInline,
  ...Map,
  ...Message,
  ...MultiLevelSelect,
  ...MultipleUsers,
  ...MultipleUsersStacked,
  ...Nav,
  ...OnlineStatus,
  ...Overlay,
  ...Pagination,
  ...Passphrase,
  ...PbBarGraph,
  ...PbCircleChart,
  ...PbGaugeChart,
  ...PbLineGraph,
  ...PbReactPopover,
  ...Person,
  ...PersonContact,
  ...PhoneNumberInput,
  ...Pill,
  ...ProgressPills,
  ...ProgressSimple,
  ...ProgressStep,
  ...Radio,
  ...RichTextEditor,
  ...SectionSeparator,
  ...Select,
  ...SelectableCard,
  ...SelectableCardIcon,
  ...SelectableIcon,
  ...SelectableList,
  ...SkeletonLoading,
  ...Source,
  ...StarRating,
  ...StatChange,
  ...StatValue,
  ...Table,
  ...TextInput,
  ...Textarea,
  ...Time,
  ...TimePicker,
  ...TimeRangeInline,
  ...TimeStacked,
  ...Timeline,
  ...Timestamp,
  ...Title,
  ...TitleCount,
  ...TitleDetail,
  ...Toggle,
  ...Tooltip,
  ...Typeahead,
  ...User,
  ...UserBadge,
  ...WeekdayStacked,
})
